export default {
  install(Vue) {
    Vue.prototype.$isPermitted = function(permissionName) {
      const perm = localStorage.getItem("permissions");
      if (perm) {
        const currentPermissions = perm.split(", ");

        // const allPermissions = [
        //     {id: 1, name: 'changeStatusCmr'},
        //     {id: 2, name: 'viewCmrs'},
        //     {id: 3, name: 'modifyCmrs'},
        //     {id: 4, name: 'createCmr'},
        //     {id: 5, name: 'deleteCmrs'},
        //     {id: 6, name: 'signCmrs'},
        //     {id: 7, name: 'modifyOrDeleteRoles'},
        //     {id: 8, name: 'assignRole'},
        //     {id: 9, name: 'viewRoles'},
        //     {id: 10, name: 'modifyOrDeleteOrganizations'},
        //     {id: 11, name: 'viewOrganizations'},
        //     {id: 12, name: 'usePortal'},
        //     {id: 13, name: 'useMobileApp'},
        //     {id: 14, name: 'addDriverUser'},
        //     {id: 15, name: 'addGovernmentUser'},
        //     {id: 16, name: 'addPhoto'},
        //     {id: 17, name: 'deletePhoto'},
        //     {id: 18, name: 'viewTransicsCredentials'},
        //     {id: 19, name: 'createOrModifyTransicsCredentials'},
        //     {id: 20, name: 'confirmGoodsAndContainers'},
        //     {id: 21, name: 'viewUsers'},
        //     {id: 22, name: 'viewProfile'},
        //     {id: 23, name: 'addOtherUsers'},
        //     {id: 24, name: 'modifyUser'},
        //     {id: 25, name: 'deleteUser'},
        //     {id: 26, name: 'addSuperAdminUser'},
        //     {id: 27, name: 'addCompanyAdminUser'},
        //     {id: 28, name: 'viewDashboard'},
        //     {id: 29, name: 'createOrganizations'},
        //     {id: 30, name: 'createPioniraCmr'},
        //     {id: 31, name: 'SetOrUnsetUnfinishedStatusOfCMR'},
        //
        // ];
        const allPermissions = [
          "",
          "changeStatusCmr",
          "viewCmrs",
          "modifyCmrs",
          "createCmr",
          "deleteCmrs",
          "signCmrs",
          "modifyOrDeleteRoles",
          "assignRole",
          "viewRoles",
          "modifyOrDeleteOrganizations",
          "viewOrganizations",
          "usePortal",
          "useMobileApp",
          "addDriverUser",
          "addGovernmentUser",
          "addPhoto",
          "deletePhoto",
          "viewTransicsCredentials",
          "createOrModifyTransicsCredentials",
          "confirmGoodsAndContainers",
          "viewUsers",
          "viewProfile",
          "addOtherUsers",
          "modifyUser",
          "deleteUser",
          "addSuperAdminUser",
          "addCompanyAdminUser",
          "viewDashboard",
          "createOrganizations",
          "createPioniraCmr",
          "SetOrUnsetUnfinishedStatusOfCMR",
          "",
          "deleteDocuments",
        ];

        return currentPermissions
          .map((el) => allPermissions[el])
          .includes(permissionName);
      }
      return "";
    };
  },
};
